import { PRODUCT_OWNERS } from '@felix/domain';
import type { Messages } from './en.js';

/** Türkçe (ikinci dil). */
export const tr: Messages = {
  brand: {
    headline: 'Gemide ve ofiste planlı bakım ve ISM.',
    subline:
      'Makine dairesinden ofise tek kayıt: denizde internetsiz çalışır, bağlantı gelince imzalı paketlerle senkron olur.',
    features: {
      offline: {
        title: 'Deniz için yapıldı',
        text: 'Her geminin kendi sunucusu var. Çalışmak için internet gerekmez.',
      },
      audit: {
        title: 'Denetime hazır',
        text: 'Klas denetimi için tasarlanmış değiştirilemez geçmiş ve onaylar.',
      },
      sync: {
        title: 'İmzalı senkron',
        text: 'Numaralı, hash zincirli ve uçtan uca doğrulanabilen paketler.',
      },
    },
    footnote: `© {{year}} ${PRODUCT_OWNERS} · Felixmate {{version}}`,
  },
  language: {
    label: 'Dil',
    en: 'EN',
    tr: 'TR',
    name: { en: 'English', tr: 'Türkçe' },
  },
  common: { loading: 'Yükleniyor' },
  login: {
    title: 'Giriş yap',
    subtitle: 'Şirket e-postanız ve parolanızla devam edin.',
    email: 'E-posta',
    emailPlaceholder: 'ad@sirket.com',
    password: 'Parola',
    submit: 'Devam et',
    footnote: 'İki adımlı doğrulama Ayarlar’da açılabilir.',
    forgot:
      'Parolanızı mı unuttunuz? Sıfırlaması için şirket yöneticinize ya da crew manager’a başvurun.',
  },
  password: {
    eyebrow: 'İlk giriş',
    title: 'Yeni parola belirleyin',
    subtitle: 'Devam etmeden önce geçici parolanızı değiştirmeniz gerekiyor.',
    current: 'Geçici parola',
    next: 'Yeni parola',
    confirm: 'Yeni parola (tekrar)',
    ruleLength: 'En az 12 karakter',
    ruleEmail: 'E-posta adınızı içermiyor',
    ruleMatch: 'İki giriş aynı',
    submit: 'Parolayı kaydet',
    changeTitle: 'Parolayı değiştir',
    changeSubtitle:
      'Mevcut parolanızı girin ve yeni bir parola seçin. Diğer oturumlarınız kapatılır.',
    currentPassword: 'Mevcut parola',
    cancel: 'Vazgeç',
    changed: 'Parolanız değiştirildi.',
  },
  totpSetup: {
    step: 'Adım {{n}} / {{total}}',
    title: 'İki adımlı doğrulamayı kurun',
    subtitle:
      'Kodu bir doğrulama uygulamasıyla okutun (Google Authenticator, Microsoft Authenticator, 1Password…).',
    qrAlt: 'Doğrulama uygulaması için QR kodu',
    manual: 'Okutamıyor musunuz? Bu anahtarı girin',
    copy: 'Anahtarı kopyala',
    copied: 'Kopyalandı',
    code: 'Uygulamadaki 6 haneli kodu girin',
    digit: '6 haneden {{n}}.',
    submit: 'Doğrula ve bitir',
  },
  twoStep: {
    enableTitle: 'İki adımlı doğrulamayı aç',
    disableTitle: 'İki adımlı doğrulamayı kapat',
    steps: {
      label: 'Adımlar',
      password: 'Parolayı onayla',
      app: 'Uygulamayı bağla',
      completed: 'tamamlandı',
    },
    passwordText: 'Devam etmek için parolanızı girin.',
    password: 'Parola',
    continue: 'Devam et',
    cancel: 'Vazgeç',
    scan: 'Kodu bir doğrulama uygulamasıyla okutun (Google Authenticator, Microsoft Authenticator, 1Password…), sonra uygulamanın gösterdiği 6 haneli kodu girin.',
    finish: 'Aç',
    enabled: 'İki adımlı doğrulama açık.',
    enabledText:
      'Artık her girişte parolanızdan sonra doğrulama uygulamanızdaki kod sorulur. Diğer oturumlarınız kapatıldı. Telefonunuzu kaybederseniz şirket yöneticiniz iki adımlı doğrulamayı kapatabilir.',
    done: 'Tamam',
    disableText: 'Parolanızı ve doğrulama uygulamanızdaki güncel kodu girin.',
    disableWarning: 'Girişte yalnız parolanız sorulur. Diğer oturumlarınız kapatılır.',
    code: 'Doğrulama kodu',
    // Pencereyi kapatan X de "Kapat": eylem neyi kapattığını söyler
    disable: 'Doğrulamayı kapat',
    disabled: 'İki adımlı doğrulama kapalı.',
    close: 'Kapat',
  },
  totp: {
    title: 'İki adımlı doğrulama',
    subtitle: 'Doğrulama uygulamanızdaki 6 haneli kodu girin.',
    code: 'Doğrulama kodu',
    digit: '6 haneden {{n}}.',
    submit: 'Doğrula',
    other: 'Başka bir hesapla giriş yap',
  },
  dashboard: {
    subtitle: 'Filo, personel ve uygunluk bir bakışta',
    summary: 'Özet',
    tiles: {
      vessels: 'Gemiler',
      active: 'Çalışan gemi sunucusu',
      onBoard: 'Gemideki personel',
      ashore: 'Karadaki personel',
      certificates: 'Belge uyarıları',
      rest: 'Dinlenme ihlali (dün)',
    },
    viewAll: 'Tümü',
    vessels: {
      title: 'Gemiler',
      vessel: 'Gemi',
      imo: 'IMO',
      crew: 'Gemide',
      server: 'Gemi sunucusu',
    },
    quickActions: 'Hızlı İşlemler',
    unavailable: 'Uyarılar okunamadı. Kendiliğinden yenilenecek.',
    noCards: 'Rolünüz için pano kartı yok.',
    noCardsHint: 'Görebildiğiniz sayfaları menüden açın.',
    actions: {
      addVessel: 'Gemi ekle',
      certificates: 'Personel belgeleri',
      restHours: 'Çalışma ve dinlenme saatleri',
      crew: 'Personel listesi',
    },
  },
  settings: {
    companyInfo: {
      title: 'Şirket bilgileri',
      legalName: 'Ticari unvan',
      address: 'Adres',
      tax: 'Vergi dairesi / no',
      phone: 'Telefon',
      email: 'Genel e-posta',
      website: 'Web sitesi',
      person: 'Yetkili kişi',
      contract: 'Felixmate aboneliği',
      status: {
        none: 'Kayıtlı değil',
        scheduled: 'Başlamadı',
        active: 'Aktif',
        expiring: 'Bitmek üzere',
        expired: 'Süresi doldu',
      },
      endsOn: 'Bitiş: {{date}}',
      daysLeft_one: '{{count}} gün kaldı',
      daysLeft_other: '{{count}} gün kaldı',
      empty: 'Henüz şirket bilgisi kaydedilmemiş.',
      readOnly:
        'Bu bilgiler Felixmate tarafından tutulur. Değişiklik için Felixmate desteğine başvurun.',
    },
    subtitle: 'Dil, hesap ve şirket ayarları',
    branding: {
      title: 'Şirket markası',
      text: 'Ofiste ve her gemide menünün üstünde görünür. Ürün adı ve sürüm satırı her zaman Felixmate kalır.',
      name: 'Şirket adı',
      tagline: 'Alt satır',
      vesselSlogan: 'Menü altı sloganı',
      vesselSloganHint: '“·” ile ayrılmış iki satır. Gemide üst satır gemi adıdır.',
      loading: 'Şirket markası yükleniyor',
      chooseLogo: 'Logo seç',
      removeLogo: 'Logoyu kaldır',
      logoHint: 'PNG, JPEG, WebP ya da SVG; en çok 64 KB. Kare görseller en iyi görünür.',
      logoType: 'PNG, JPEG, WebP ya da SVG bir görsel seçin.',
      logoSize: 'Logo en çok 64 KB olmalı.',
      tooLong: 'Çok uzun.',
      save: 'Markayı kaydet',
      saved: 'Kaydedildi. Gemilere sonraki senkronla iner.',
    },
    language: { title: 'Dil', text: 'Varsayılan dil İngilizce; Türkçe seçilebilir.' },
    account: {
      title: 'Hesap',
      name: 'Ad',
      email: 'E-posta',
      security: 'Giriş',
      securityValue: 'Parola ve iki adımlı doğrulama',
    },
  },
  fleet: {
    title: 'Filo',
    subtitle: 'Şirketinizin gemileri ve gemi sunucuları',
    summary: {
      label: 'Filo özeti',
      total: 'Gemi',
      active: 'Gemi sunucusu etkin',
      pending: 'Etkinleştirme bekliyor',
    },
    name: 'Gemi',
    imo: 'IMO',
    status: 'Gemi sunucusu',
    actions: 'İşlemler',
    activated: 'Etkin',
    notActivated: 'Etkinleştirilmedi',
    // Kurulum aşaması (ADR 0142)
    stage: { label: 'Aşama', setup: 'Kurulum', live: 'Kullanımda' },
    goLive: {
      action: 'Kullanıma al',
      title: '{{vessel}} kullanıma alınsın',
      text: 'Kurulum aşamasında ofis yanlışlıkla açtığı doküman klasörünü de kaldırabilir; gemi kullanıma alınınca klasör kaldırılmaz, emekliye ayrılır. Ofis PMS ağacını düzenlemeye devam eder: değişiklik gemiye gönderilir ve geminin sonraki senkronunda uygulanır.',
      warning: 'Bu işlem ofisten geri alınamaz. Doküman ağacının tamam olduğundan emin olun.',
      cancel: 'Vazgeç',
      confirm: 'Kullanıma al',
    },
    timeZone: 'Gemi saat dilimi: {{zone}}',
    add: 'Gemi ekle',
    setupCode: 'Kurulum kodu',
    more: '{{vessel}} için diğer işlemler',
    closeDialog: 'Kapat',
    replaceServer: 'Gemi sunucusunu değiştir…',
    denied: {
      permission: '{{module}} ▸ {{action}}',
      scope: { fleet: 'filo genelinde', vessel: 'bu gemide' },
      short: 'Gerekli yetki: {{scope}} {{permission}} (varsayılan: {{role}}).',
      add: 'Gemi eklemek için {{scope}} {{permission}} yetkisi gerekir (varsayılan: {{role}}).',
      setupCode:
        'Kurulum kodu için {{scope}} {{permission}} yetkisi gerekir (varsayılan: {{role}}).',
      replaceServer:
        'Gemi sunucusunu değiştirmek için {{scope}} {{permission}} yetkisi gerekir (varsayılan: {{role}}).',
      goLive:
        'Kullanıma almak için {{scope}} {{permission}} yetkisi gerekir (varsayılan: {{role}}).',
      particulars:
        'Gemi bilgilerini düzenlemek için {{scope}} {{permission}} yetkisi gerekir (varsayılan: {{role}}).',
    },
    emptyTitle: 'Henüz gemi yok',
    emptyText: 'İlk geminizi ekleyin, sonra gemi sunucusunu kurulum koduyla etkinleştirin.',
    error: 'Filo yüklenemedi.',
    retry: 'Tekrar dene',
    guide: {
      title: 'Gemiyi devreye alma',
      step1: 'Gemiyi IMO numarası ve gemi saat dilimiyle ekleyin.',
      step2: 'Kurulum kodu oluşturun. Kod 24 saat geçerlidir ve bir kez kullanılır.',
      step3: 'Gemi sunucusunu kaptan PC’sine kurun ve kodu girin.',
      step4: 'Bundan sonra kayıtlar, gemi internete çıktıkça imzalı paketlerle ofise ulaşır.',
    },
    addForm: {
      title: 'Gemi ekle',
      description:
        'Gemi sunucusu etkinleşene kadar geminin verisini ofis tutar; sonra gemi kendi kayıtlarını kendisi yazar.',
      name: 'Gemi adı',
      namePlaceholder: 'M/V Ocean Star',
      imo: 'IMO numarası',
      imoHint: '7 hane',
      imoInvalid: '7 haneli IMO numarasını girin.',
      nameRequired: 'Gemi adını girin.',
      timeZone: 'Gemi saat dilimi',
      timeZoneHint: 'Gemide “işin yapıldığı gün” buna göre belirlenir.',
      template: 'Doküman şablonu',
      templateHint:
        'Gemi eklenirken ISM Formları ve El Kitapları klasör ağacı bu şablondan kopyalanır. Sonradan yalnız Felixmate değiştirebilir.',
      templateSingle:
        'Şirketinizin tek doküman şablonu var. Gemi eklenirken klasör ağacı ondan kopyalanır.',
      templateLoading: 'Şablonlar yükleniyor…',
      templateRequired: 'Bir doküman şablonu seçin.',
      templateErrors: {
        GENERIC: 'Doküman şablonları yüklenemedi. Pencereyi kapatıp yeniden deneyin.',
        NETWORK: 'Doküman şablonları yüklenemedi (bağlantı yok). Yeniden deneyin.',
        DOC_TEMPLATE_REQUIRED:
          'Şirketinize açık doküman şablonu yok. Felixmate desteğinden açmasını isteyin.',
      },
      cancel: 'Vazgeç',
      submit: 'Gemiyi ekle',
    },
    code: {
      title: '{{vessel}} için kurulum kodu',
      intro:
        'Gemi sunucusu bu kodu bir kez kullanarak ofise kaydolur. Kodu bilen herkes bu gemi için sunucu etkinleştirebilir; kodu yalnız kaptanla paylaşın.',
      replaceWarning:
        'Bu geminin etkin bir gemi sunucusu var. Yenisini etkinleştirmek mevcut sunucuyu devreden çıkarır; onun bundan sonra gönderdiği paketler reddedilir ve raporlanır.',
      create: 'Kurulum kodu oluştur',
      password: 'Parolanız',
      passwordHelp:
        'Kurulum kodu bu gemiye yeni bir gemi sunucusu bağlar; onaylamak için kendi parolanızı girin.',
      creating: 'Oluşturuluyor…',
      label: 'Kurulum kodu',
      copy: 'Kodu kopyala',
      copied: 'Kopyalandı',
      validUntil: '{{date}} tarihine kadar geçerli',
      onceOnly: 'Bu kod yalnız bir kez gösterilir. Kaybolursa yenisini oluşturun.',
      next: 'Kaptan PC’sinde gemi sunucusu kurulumu kodu istediğinde bu kodu girin.',
      close: 'Tamam',
      cancel: 'Vazgeç',
    },
  },
  errors: {
    SHIP_SERVER_NOT_ACTIVATED:
      'Önce geminin sunucusunu etkinleştirin; o zamana kadar geminin verisini ofis tutar.',
    ALREADY_LIVE: 'Gemi zaten kullanımda.',
    DOC_TEMPLATE_REQUIRED:
      'Şirketinize açık doküman şablonu yok. Felixmate desteğinden açmasını isteyin.',
    DOC_TEMPLATE_UNAVAILABLE: 'Bu doküman şablonu şirketinize açık değil.',
    INVALID_LOGO: 'Logo PNG, JPEG, WebP ya da SVG bir görsel olmalı.',
    LOGO_TOO_LARGE: 'Logo en çok 64 KB olmalı.',
    INVALID_CREDENTIALS: 'E-posta ya da parola hatalı.',
    INVALID_TOTP: 'Kod geçerli değil. Telefonunuzun saatini kontrol edip tekrar deneyin.',
    TOTP_ALREADY_ENABLED: 'Hesabınızda iki adımlı doğrulama zaten açık.',
    TOTP_UNAVAILABLE: 'Bu hesapta iki adımlı doğrulama kullanılamaz.',
    TOTP_NOT_ENROLLED: 'Hesabınızda iki adımlı doğrulama zaten kapalı.',
    INVALID_PASSWORD: 'Parola doğru değil.',
    INVALID_CURRENT_PASSWORD: 'Mevcut parola doğru değil.',
    TOO_MANY_ATTEMPTS: 'Çok fazla deneme. 15 dakika bekleyip yeniden deneyin.',
    PASSWORD_TOO_SHORT: 'Parola en az 12 karakter olmalı.',
    PASSWORD_TOO_LONG: 'Parola çok uzun.',
    PASSWORD_CONTAINS_EMAIL: 'Parola e-posta adınızı içermemeli.',
    NETWORK: 'Sunucuya bağlanılamadı. Ağınızı kontrol edip tekrar deneyin.',
    UNAUTHENTICATED: 'Oturumunuz sona erdi. Lütfen tekrar giriş yapın.',
    VALIDATION_FAILED: 'Bazı alanlar geçerli değil. Kontrol edip tekrar deneyin.',
    FORBIDDEN: 'Bunun için yetkiniz yok.',
    EXPIRES_BEFORE_ISSUED: 'Bitiş tarihi veriliş tarihinden sonra olmalı.',
    ROW_VERSION_CONFLICT: 'Kaydı başka biri değiştirdi. Yenileyip tekrar deneyin.',
    REAUTHENTICATION_REQUIRED: 'Parolanızı girin.',
    GENERIC: 'Bir şeyler ters gitti. Lütfen tekrar deneyin.',
  },
};
